// /**
//  * Script that adds additional empty water bottles fpr product page
//  * Implemented: layout\theme.liquid
//  */

// document.addEventListener("DOMContentLoaded", async function () {
//   //   const new_bottle_variant_id = "46550698590447";
//   const new_bottle_variant_ids = [
//     "46550698590447",
//     "46584026890479",
//     "46550709043439",
//     "46584029118703",
//   ];
//   const empty_bottle_id = 46876520710383;

//   // detect variant id from URL
//   function variantURL() {
//     return new Promise((res) =>
//       setTimeout(() => {
//         const variant_url = new URLSearchParams(window.location.search).get(
//           "variant"
//         );
//         res(variant_url);
//       }, 0)
//     );
//   }

//   // first render
//   const current_variant_id = await variantURL();
//   if (new_bottle_variant_ids.includes(current_variant_id)) {
//     const add_to_cart_btn = document.querySelector('[ref="addToCartButton"]');
//     if (!add_to_cart_btn) {
//       return console.log(
//         "Invalid FR- Cant find add to cart button DOM element"
//       );
//     }
//     add_to_cart_btn.addEventListener("click", handlePost);
//   }

//   // variant on change
//   navigation.addEventListener("navigate", async function (e) {
//     const onchange_variant_id = await variantURL();
//     console.log({ variant_id: onchange_variant_id });

//     if (!new_bottle_variant_ids.includes(onchange_variant_id)) {
//       const add_to_cart_btn = document.querySelector('[ref="addToCartButton"]');
//       if (!add_to_cart_btn) {
//         return console.log(
//           "Invalid - Cant find add to cart button DOM element"
//         );
//       }
//       add_to_cart_btn.removeEventListener("click", handlePost);
//       return console.log("Invalid variant match");
//     }

//     console.log("Variant id matched: Provide additional empty water bottles");

//     const add_to_cart_btn = document.querySelector('[ref="addToCartButton"]');
//     if (!add_to_cart_btn) {
//       return console.log("Cant find add to cart button DOM element");
//     }

//     //console.log({add_to_cart_btn})
//     add_to_cart_btn.addEventListener("click", handlePost);
//   });

//   async function handlePost() {
//     setTimeout(async () => {
//       const input_qty = document.querySelector(
//         "quantity-selector-component [ref='quantityInput']"
//       );
//       if (!input_qty) {
//         return console.log("Cant find input_qty DOM element");
//       }

//       console.log(input_qty.value);

//       const payload = {
//         items: [
//           {
//             id: empty_bottle_id,
//             quantity: Number(input_qty.value),
//           },
//         ],
//       };

//       await postCartData(payload);
//       const cart = await getCartData();
//       console.log(cart);

//       // update slider UI
//       const formatted_total = formatMoney(cart.total_price);

//       const slider_total_el = document.querySelector(
//         'cart-items-component [ref="cartTotal"]'
//       );
//       const slider_qty_el = document.querySelector(
//         'cart-items-component [ref="cartBubbleCount"]'
//       );
//       const message_el = document.querySelector("[data-js-slider-message]");
//       if (!slider_total_el || !slider_qty_el || !message_el) {
//         return console.log("Cant find slider elements");
//       }

//       slider_total_el.value = formatted_total;
//       slider_total_el.innerText = formatted_total;
//       slider_qty_el.innerText = cart.item_count;

//       const message = `A total of ${input_qty.value} empty new bottles were added to the cart.`;
//       message_el.innerText = message;
//     }, 1000);
//   }

//   // utils
//   async function postCartData(item) {
//     try {
//       const res = await fetch(window.Shopify.routes.root + "cart/add.js", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(item),
//       });
//       const data = await res.json();
//       return data;
//     } catch (error) {
//       console.log("Error POST cart data", error);
//     }
//   }

//   async function getCartData() {
//     try {
//       const res = await fetch("/cart.js");
//       const data = await res.json();
//       return data;
//     } catch (error) {
//       console.log("Error fetching cart data", error);
//     }
//   }

//   function formatMoney(price, currencyCode = "USD") {
//     const formattedPrice = (price / 100).toFixed(2);
//     return `$${formattedPrice} ${currencyCode}`;
//   }
// });


/**
 * Add extra empty water bottles on eligible product variants.
 * Works on **all browsers** – Safari, Chrome, Firefox, Edge, iOS, Android.
 */

document.addEventListener("DOMContentLoaded", async function () {
  /* ------------------------------------------------------------------ */
  /* 1. Configuration                                                   */
  /* ------------------------------------------------------------------ */
  const new_bottle_variant_ids = [
    "46550698590447",
    "46584026890479",
    "46550709043439",
    "46584029118703",
  ];
  const empty_bottle_id = 46876520710383;

  /* ------------------------------------------------------------------ */
  /* 2. Helper: read current variant id from URL                       */
  /* ------------------------------------------------------------------ */
  function getCurrentVariantId() {
    return new URLSearchParams(window.location.search).get("variant");
  }

  /* ------------------------------------------------------------------ */
  /* 3. Core: attach / detach the click handler                         */
  /* ------------------------------------------------------------------ */
  async function updateAddToCartHandler() {
    const variantId = getCurrentVariantId();
    console.log("[variant] current id →", variantId);

    const addBtn = document.querySelector('[ref="addToCartButton"]');
    if (!addBtn) {
      console.warn("Add-to-cart button not found");
      return;
    }

    // Always clean any previous listener first
    addBtn.removeEventListener("click", handlePost);

    if (!variantId || !new_bottle_variant_ids.includes(variantId)) {
      console.log("Variant NOT eligible – listener removed");
      return;
    }

    console.log("Variant eligible – attaching extra-bottle handler");
    addBtn.addEventListener("click", handlePost);
  }

  /* ------------------------------------------------------------------ */
  /* 4. Click handler – adds empty bottles + UI update                  */
  /* ------------------------------------------------------------------ */
  async function handlePost() {
    // Give Shopify a moment to add the main product to the cart
    setTimeout(async () => {
      const qtyInput = document.querySelector(
        "quantity-selector-component [ref='quantityInput']"
      );
      if (!qtyInput) {
        console.warn("Quantity input not found");
        return;
      }

      const qty = Number(qtyInput.value) || 1;
      console.log("Adding", qty, "empty bottles (id:", empty_bottle_id, ")");

      const payload = {
        items: [{ id: empty_bottle_id, quantity: qty }],
      };

      await postCartData(payload);
      const cart = await getCartData();

      // ---- UI updates -------------------------------------------------
      const formatted = formatMoney(cart.total_price);
      const totalEl = document.querySelector('cart-items-component [ref="cartTotal"]');
      const countEl = document.querySelector('cart-items-component [ref="cartBubbleCount"]');
      const msgEl   = document.querySelector("[data-js-slider-message]");

      if (totalEl) totalEl.innerText = totalEl.value = formatted;
      if (countEl) countEl.innerText = cart.item_count;
      if (msgEl) {
        msgEl.innerText = `A total of ${qty} empty new bottles were added to the cart.`;
      }
    }, 1000);
  }

  /* ------------------------------------------------------------------ */
  /* 5. Cart utilities (unchanged)                                      */
  /* ------------------------------------------------------------------ */
  async function postCartData(item) {
    try {
      const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(item),
      });
      return await res.json();
    } catch (e) {
      console.error("postCartData error", e);
    }
  }

  async function getCartData() {
    try {
      const res = await fetch("/cart.js");
      return await res.json();
    } catch (e) {
      console.error("getCartData error", e);
    }
  }

  function formatMoney(price, currency = "USD") {
    const amount = (price / 100).toFixed(2);
    return `$${amount} ${currency}`;
  }

  /* ------------------------------------------------------------------ */
  /* 6. Run once on page load                                           */
  /* ------------------------------------------------------------------ */
  updateAddToCartHandler();

  /* ------------------------------------------------------------------ */
  /* 7. URL change detection (popstate + hashchange)                    */
  /* ------------------------------------------------------------------ */
  window.addEventListener("popstate", updateAddToCartHandler);
  window.addEventListener("hashchange", updateAddToCartHandler);

  /* ------------------------------------------------------------------ */
  /* 8. DOM mutation detection (Shopify swaps variant UI via JS)       */
  /* ------------------------------------------------------------------ */
  const observer = new MutationObserver(() => {
    // Debounce – max once every 150 ms
    clearTimeout(window._variantDebounce);
    window._variantDebounce = setTimeout(updateAddToCartHandler, 150);
  });

  // Observe the product form / variant selector area.
  // Adjust the selector if your theme uses something different.
  const observeRoot =
    document.querySelector('[data-product-form], .product-form, [data-variant-selector]') ||
    document.body;

  observer.observe(observeRoot, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["value", "data-variant-id", "href", "src"],
  });

  /* ------------------------------------------------------------------ */
  /* OPTIONAL: If you control the variant change code elsewhere, you   */
  /* can fire a custom event:                                           */
  /*   window.dispatchEvent(new Event('variantchange'));               */
  /* ------------------------------------------------------------------ */
  window.addEventListener("variantchange", updateAddToCartHandler);
});
